import { NgModule } from '@angular/core';
import { CommonModule as NgCommonModule } from '@angular/common';
import { LandingComponent } from './landing/landing.component';
import { MatCardModule } from '@angular/material/card';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { UsersModule } from '../users/users.module';
import { AlertsModule } from '../common/alerts/alerts.module';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { GtagModule } from 'angular-gtag';
import { FeaturesComponent } from './features/features.component';
import { PricingComponent } from './pricing/pricing.component';
import { ContactComponent } from './contact/contact.component';
import { SignupComponent } from './signup/signup.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRadioModule } from '@angular/material/radio';
import { NgxStripeModule } from 'ngx-stripe';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DecksModule } from '../decks/decks.module';
import { CommonModule } from '../common/common.module';
import { PricingBlockComponent } from './pricing-block/pricing-block.component';

@NgModule({
    declarations: [LandingComponent, FeaturesComponent, PricingComponent, ContactComponent, SignupComponent, PricingBlockComponent],
    imports: [
        AlertsModule,
        NgCommonModule,
        MatCardModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        UsersModule,
        MatToolbarModule,
        RouterModule,
        GtagModule,
        MatTabsModule,
        MatRadioModule,
        NgxStripeModule,
        MatCheckboxModule,
        DecksModule,
        CommonModule
    ]
})
export class LandingModule {
}
